module.exports = __webpack_public_path__ + "images/backgrounds/pdf-sun-6e4a7033cf3f3c64bd93f413788f028d.webp";